import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import VoteAddList from './components/VoteAddList';

const { Cell } = ResponsiveGrid;

const Vote = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="發起投票"
        // description="發起投票"
        breadcrumbs={[
          {
            name: '投票活動',
          },
          {
            name: '發起投票',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <VoteAddList />
    </Cell>
  </ResponsiveGrid>
);

export default Vote;
